var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import React from "react";
import { EnumSalesFilter } from "@domains/salesFeatures/Common/entities/IFilterDataEntity";
import loginDI from "@frameworks/salesjourney/components/Login/di/index";
import Diamond from "@frameworks/shared-library/assets/images/SalesJourney/ClientDetails/ClientTier/Diamond.svg";
import Black from "@frameworks/shared-library/assets/images/SalesJourney/ClientDetails/ClientTier/Black.svg";
import Blue from "@frameworks/shared-library/assets/images/SalesJourney/ClientDetails/ClientTier/Blue.svg";
import Bronze from "@frameworks/shared-library/assets/images/SalesJourney/ClientDetails/ClientTier/Bronze.svg";
import Gold from "@frameworks/shared-library/assets/images/SalesJourney/ClientDetails/ClientTier/Gold.svg";
import Platinum from "@frameworks/shared-library/assets/images/SalesJourney/ClientDetails/ClientTier/Platinum.svg";
import Silver from "@frameworks/shared-library/assets/images/SalesJourney/ClientDetails/ClientTier/Silver.svg";
export var removeLocalStorageDataIfExist = function (localStorageKeys) {
    localStorageKeys.forEach(function (key) {
        var value = localStorage.getItem(key);
        value && localStorage.removeItem(key);
    });
};
export function handleDisableFilter(filterList, filtersToBeEnable) {
    var _a = loginDI.login.getIsRMPartnerFRM(), isPartner = _a.isPartner, isFRM = _a.isFRM, isRM = _a.isRM;
    return isPartner
        ? filterList === null || filterList === void 0 ? void 0 : filterList.filter(function (filter) { return filter.value !== EnumSalesFilter.partnerId; }).map(function (oneFilter) {
            return isRM
                ? oneFilter
                : __assign(__assign({}, oneFilter), { disabled: !(filtersToBeEnable === null || filtersToBeEnable === void 0 ? void 0 : filtersToBeEnable.includes(oneFilter === null || oneFilter === void 0 ? void 0 : oneFilter.value)) });
        })
        : filterList;
}
export var getFilterDropdownList = function (filterName) {
    switch (filterName) {
        case EnumSalesFilter.followupCount:
            return [
                {
                    title: "1-3",
                    value: "1-3",
                    checked: false,
                },
                {
                    title: "4-6",
                    value: "4-6",
                    checked: false,
                },
                {
                    title: "7-9",
                    value: "7-9",
                    checked: false,
                },
                {
                    title: ">9",
                    value: "9",
                    checked: false,
                },
            ];
        case EnumSalesFilter.leadType:
            return [
                {
                    title: "Partner",
                    value: "1",
                    checked: false,
                },
                {
                    title: "Client",
                    value: "2",
                    checked: false,
                },
            ];
        default:
            return [];
    }
};
export var getClientTierIcon = function (clientTier) {
    var checkClientTier = clientTier === null || clientTier === void 0 ? void 0 : clientTier.toLowerCase();
    switch (checkClientTier) {
        case "diamond":
            return React.createElement("img", { src: Diamond, alt: "diamond" });
        case "black":
            return React.createElement("img", { src: Black, alt: "diamond" });
        case "platinum":
            return React.createElement("img", { src: Platinum, alt: "diamond" });
        case "gold":
            return React.createElement("img", { src: Gold, alt: "diamond" });
        case "silver":
            return React.createElement("img", { src: Silver, alt: "diamond" });
        case "bronze":
            return React.createElement("img", { src: Bronze, alt: "diamond" });
        case "blue":
            return React.createElement("img", { src: Blue, alt: "diamond" });
        default:
            return React.createElement("img", null);
    }
};
export var getInterestedPriorityTag = function (priority) {
    var leadPriority = Number(priority);
    switch (leadPriority) {
        case 1:
            return (React.createElement("span", { className: "priority-tag" },
                React.createElement("i", { className: "edel-icon-cold-text" })));
        case 2:
            return (React.createElement("span", { className: "priority-tag" },
                React.createElement("i", { className: "edel-icon-hot-text" })));
        case 3:
            return (React.createElement("span", { className: "priority-tag" },
                React.createElement("i", { className: "edel-icon-warm-text" })));
        default:
            return React.createElement(React.Fragment, null);
    }
};
var enabledLeaddashboardFilters = [
    EnumSalesFilter.clientTier,
    EnumSalesFilter.bucketId,
    EnumSalesFilter.displayId,
    EnumSalesFilter.custType,
    EnumSalesFilter.expiryId,
    EnumSalesFilter.productId,
    EnumSalesFilter.mode,
    EnumSalesFilter.status,
    EnumSalesFilter.interactionStatus,
    EnumSalesFilter.interactionSubStatus,
    EnumSalesFilter.participants,
    EnumSalesFilter.categoryId,
    EnumSalesFilter.isCommented,
    EnumSalesFilter.sourceId,
    EnumSalesFilter.subSourceId,
    EnumSalesFilter.isUncalledLeads,
    EnumSalesFilter.followupCount,
];
var enabledHomedashboardFilters = [EnumSalesFilter.clientTier];
export var ESalesRatingMsg;
(function (ESalesRatingMsg) {
    ESalesRatingMsg["HOMEPAGE"] = "How would you like to rate us on the dashboard insights?";
    ESalesRatingMsg["LEAD_DASHBOARD"] = "How would you like to rate us on the lead journey?";
})(ESalesRatingMsg || (ESalesRatingMsg = {}));
export var salesDashboardID = {
    HOMEPAGE: 1,
    LEAD_DASHBOARD: 2,
};
export var dashboardRatingMsg = (_a = {},
    _a[salesDashboardID.HOMEPAGE] = "How would you like to rate us on the dashboard insights?",
    _a[salesDashboardID.LEAD_DASHBOARD] = "How would you like to rate us on the lead journey?",
    _a);
export { enabledLeaddashboardFilters, enabledHomedashboardFilters };
